import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MdbButtonDirective } from './button.directive';

@NgModule({
  declarations: [MdbButtonDirective],
  imports: [CommonModule],
  exports: [MdbButtonDirective],
})
export class MdbButtonModule {}
